































































































































































import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppCarouselScroll from '@/components/AppCarouselScroll.vue'
import AppRouterLink from '@/components/AppRouterLink.vue'
import AppSectionBanners from '@/components/AppSectionBanners.vue'
import AppSectionCategories from '@/components/AppSectionCategories.vue'
import AppSectionEditorsPick from '@/components/AppSectionEditorsPick.vue'
import AppSectionGridItem from '@/components/AppSectionGridItem.vue'
import AppSectionPatternGrid from '@/components/AppSectionPatternGrid.vue'
import AppSectionTile from '@/components/AppSectionTile.vue'
import AppSectionTileBrand from '@/components/AppSectionTileBrand.vue'
import AppSectionTileItem2 from '@/components/AppSectionTileItem2.vue'
import AppSectionTileLayer from '@/components/AppSectionTileLayer.vue'
import AppSectionTileUser from '@/components/AppSectionTileUser.vue'
import AppSectionTimedSale from '@/components/AppSectionTimedSale.vue'
import AppSectionTabGrid from '@/components/AppSectionTabGrid.vue'
import { Common } from '@/mixins'

@Component({
  components: {
    AppCarouselScroll,
    AppRouterLink,
    AppSectionBanners,
    AppSectionCategories,
    AppSectionEditorsPick,
    AppSectionGridItem,
    AppSectionPatternGrid,
    AppSectionTile,
    AppSectionTileBrand,
    AppSectionTileItem2,
    AppSectionTileLayer,
    AppSectionTileUser,
    AppSectionTimedSale,
    AppSectionTabGrid
  }
})
export default class extends Mixins(Common) {
  @Prop(String) readonly layoutType!: string
  @Prop(Object) readonly option!: { saleExpiredAt: number } | null
  @Prop(String) readonly dataType!: string
  @Prop(Object) readonly data!: { feeds: object[]; items: {
    isActive: boolean;
    display: boolean;
    seller: { shop: { status: string } };
  }[]; }

  @Prop(String) readonly dataPopulationType!: string
  @Prop(Object) readonly searchOption!: {
    query: string;
    categories: string[];
    colors: string[];
    excludeSoldOuts: boolean;
    showOnlyDiscountedItems: boolean;
    showOnlyTimeSaleItems: boolean;
    sortSpec: string;
    minPrice: number;
    maxPrice: number;
    userId: string;
    __typename?: string;
  } | null

  @Prop(Number) readonly sectionIndex!: number
  @Prop(String) readonly sectionId!: string

  categorySelected = null
  intervalId: any = null
  now = 0
  visibleFullVerticalFeedId: string | null = null

  beforeDestroy () {
    clearInterval(this.intervalId)
  }

  mounted () {
    if (this.option && this.option.saleExpiredAt) {
      this.now = Math.floor(Date.now() / 1000)
      this.intervalId = setInterval(() => {
        console.log('AppSection setInterval')
        this.now = Math.floor(Date.now() / 1000)
      }, 1000)
    }
  }

  get dataItems () {
    return this.data.items.filter(item => item.isActive && item.display && item.seller.shop.status === 'ACTIVE')
  }

  get isValid () {
    if (this.dataPopulationType === 'TIME_SALE_ITEM' && !this.dataItems.length) return false
    return true
  }

  get isFullVerticalSection () {
    return this.dataType === 'FEED_WITH_CUSTOM_DATA' && this.sectionIndex === 0
  }

  onVisible (feedId: string) {
    if (this.isFullVerticalSection) {
      this.visibleFullVerticalFeedId = feedId
    }
  }

  get layoutTypeOverrided () {
    if (this.layoutType === 'CAROUSEL_RECT' && this.dataType === 'FEED' && this.data.feeds.length === 1) {
      return 'FULL_SQUARE'
    }
    return this.layoutType
  }

  get showMoreRoute () {
    if (this.searchOption) {
      const query = (() => {
        const retval = {
          term: this.searchOption.query || this.categorySelected || '',
          tab: this.dataType === 'FEED' ? 'FEED' : 'ITEM',
          hideUser: true
        }

        if (this.dataType === 'FEED') return retval

        const searchOption = { ...this.searchOption }
        delete searchOption.__typename

        return {
          ...searchOption,
          ...retval,
          colors: this.searchOption.colors,
          excludeSoldOuts: this.searchOption.excludeSoldOuts,
          showOnlyDiscountedItems: this.searchOption.showOnlyDiscountedItems,
          showOnlyTimeSaleItems: this.searchOption.showOnlyTimeSaleItems,
          sortSpec: this.searchOption.sortSpec,
          minPrice: this.searchOption.minPrice,
          maxPrice: this.searchOption.maxPrice,
          sellerId: this.searchOption.userId
        }
      })()

      return { path: '/search', query }
    }

    if (this.dataPopulationType === 'RECOMMENDED_SHOP') {
      return { path: '/shopping/brands', query: { category: '전체' } }
    } else if (this.dataPopulationType === 'SHOPPING_HOME_CATEGORIES') {
      return { path: '/shopping/categories' }
    } else if (this.dataPopulationType === 'TIME_SALE_ITEM') {
      return { path: '/shopping/specials' }
    } else if (this.dataPopulationType === 'CUSTOM') {
      if (this.dataType === 'FEED') {
        return { path: '/search', query: { viewSectionId: this.sectionId } }
      }
    }
    return '#'
  }

  get remainingSeconds () {
    return this.option ? this.option.saleExpiredAt - this.now : 0
  }

  get remainingMinutes () {
    return Math.floor(this.remainingSeconds / 60)
  }

  get remainingHours () {
    return Math.floor(this.remainingMinutes / 60)
  }

  getOneDigit (n: number) {
    return n % 10
  }

  getTenDigit (n: number) {
    return Math.floor(n / 10)
  }
}
